export default __webpack_public_path__ + "static/media/Beard_2_C1.0912ba3b.svg";